import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProactiveComponent } from './proactive/proactive.component';
import { SupportComponent } from './support/support.component';
import { TechnicalComponent } from './technical/technical.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ProactiveComponent, SupportComponent, TechnicalComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class TechnicalModule { }
